import styled from "styled-components";

export default styled.div`
  display: flex;
  padding: 10px 10px 8px 10px;
  background: ${props => (props.activeBackground ? "#f7f6f2" : "#fffff")};
  color: #455a64;
  border-bottom: 1.5px solid #eee;
`;
